import React from 'react';

import Typography from '@material-ui/core/Typography';

export function DashboardSection() {
  return <Typography paragraph>This is the dashboard section</Typography>;
}
